import React, {Component} from "react";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import AnnouncementForm from "./DealForm";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";
import DocumentDeleteModal from "../documentList/DocumentDeleteModal";
import AnnouncementDeleteModal from "./DealDeleteModal";
import Alert from "react-s-alert";
import DealForm from "./DealForm";
import DealDeleteModal from "./DealDeleteModal";


class DealList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            deals: [],
            userGroups: [],
            selectedDeal: null,
            deleteDealModal: false,
            selectedItem: null,
            dealAttachments: null,
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addDealModal: false,
            mode :'edit',
        };

        this.listDeals = this.listDeals.bind(this);
        this.cancelDealCreation = this.cancelDealCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.addNew=this.addNew.bind(this);
    }

    listDeals(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ("&sort=" + accessor + ',' + direction) : "&sort=id,asc";
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery ;
        let url= API_BASE_URL+"/deal/fetchDeals?page=" + page + "&size=" + size + sortStr + searchQuery ;
        let params = {
            url: url,
            method: "get",
        };
        console.log(params.url);
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log(response.data.content);
                let deals = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    deals: deals,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelDealCreation() {
        console.log("DealList.canceled!!");
        this.setState({
            addDealModal: false,
            selectedDeal: null,
            deleteDealModal: false,
        })
        this.listDeals(null, null, this.state.page, this.state.size);
    }
    handleDelete(item) {
        this.setState({
            selectedDeal: item,
            deleteDealModal: true
        })
    }
    handleYayin(item){
        let params = {
            url: API_BASE_URL+"/deal/wordpressgonder",
            data: {
                "id": item.id,
                "title": item.title,
                "text": item.text,
                "postId": item.postId,
                "endDate": item.endDate,
                "startDate": item.startDate,
                "ilanTuru": "KANS_ILAN"
            },
            method: 'post'
        };
        request(params).then(function (response) {
            const message = "Duyuru Başarıyla yayınlandı."
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
        }).catch(function (error) {
            showAxiosError(error);
        }).finally(() => {
            this.cancelDealCreation(); // ✅ this artık doğru bağlamda
        });
    }
    handleEdit(item) {
        let self = this;
        let params = {
            url: API_BASE_URL+"/deal/" +item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                selectedDeal: response.data,
                addDealModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    addNew() {
        let self = this;
        self.setState({
            selectedDeal: null,
            addDealModal: true,
            mode: 'create',
            add:true,
        })
    }

    handleSearch(searchQuery) {
        console.log("searchQuery:: ", searchQuery);
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listDeals(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    componentDidMount() {

    }


    render() {
        let self = this
        const {deals} = this.state;

        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(self.state.selectedItem)}>
                    Anlaşma Düzenle
                </Menu.Item>

                <Menu.Item onClick={() => this.handleDelete(self.state.selectedItem)}>
                    Anlaşma Sil
                </Menu.Item>

                <Menu.Item onClick={() => this.handleYayin(self.state.selectedItem)}>
                    Anlaşma Yayınla
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Başlık",
                accessor: "title",
            },
            {
                Header: "Oluşturan",
                accessor: "cuser",
            },
            {
                Header: "Yayın Tarihi",
                accessor: "",
                Cell: item => (
                    <label>{new Date(item.startDate).toLocaleDateString('tr') }</label>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu}
                                  trigger='click'
                                  onClick={() => self.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            },
            {
                Header: "Durum",
                accessor: "",
                Cell: item => {
                    const { isyayin, isupdate } = item;

                    let label = "";
                    if (isyayin && isupdate) {
                        label = "Yayınlandı & Güncelleme Var";
                    } else if (isyayin) {
                        label = "Yayınlandı";
                    } else if (isupdate) {
                        label = "Güncelleme Var";
                    }
                    return <div>{label && <span>{label}</span>}</div>;
                }
            },
        ];

        const fields = [
            {
                label: "Başlık",
                accessor: "title",
                type: "text",
                operator: "=",
            },
            {
                label: "Oluşturan",
                accessor: "cuser",
                type: "text",
                operator: "=",
            },
            {
                label: "Yayın Tarihi",
                accessor: "startDate",
                type: "date",
                operator: "=",
            },
            {
                label: "Durum",
                accessor: "durum",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="row baseBackground">
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                            <h4 className="card-title">Anlaşma Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body
                    ">
                        <div className=" ">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch}/>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={deals}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.listDeals}
                            style={{width:"100%"}}
                        />
                    </div>
                    <div className="new-button-holder">
                        {
                            (this.state.mode !== 'review') &&
                            <div className="new-button-holder">
                                <button type="button" data-placement="bottom"
                                        title="Yeni Duyuru Ekle" disabled={this.state.isLoading}
                                        style={{
                                            background: 'linear-gradient(#2b93cd, #0a66b7)',
                                            height: '40px',
                                            width: '160px',
                                            float: 'right',
                                            marginRight: '30px',
                                            color: 'white',
                                            borderRadius: '0.375em',
                                        }}
                                        className="TekBtn add-new-member "
                                        rel="tooltip"
                                        // onClick={() => this.addNew()}
                                        onClick={() => this.addNew(this.state.selectedItem)}
                                >
                                    YENİ ANLAŞMA EKLE
                                </button>
                            </div>
                        }
                    </div>
                </div>

                <Modal isOpen={this.state.addDealModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDealCreation}>
                        {this.state.add
                            ?
                            'Yeni Anlaşma Ekleme'
                            :
                            'Anlaşma Düzenleme'
                        }
                    </ModalHeader>
                      <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DealForm
                            cancelProcess={this.cancelDealCreation}
                            selectedDeal={this.state.selectedDeal}
                            mode={this.state.mode}
                            handleSearch={this.handleSearch}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.deleteDealModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelDealCreation}>
                        Duyuru Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DealDeleteModal
                            cancelProcess={this.cancelDealCreation}
                            selectedDeal={this.state.selectedDeal}
                            handleLogout={this.handleLogout}
                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}


export default DealList


// WEBPACK FOOTER //
// ./src/page/deal/DealList.js